import { Container } from "../../../components/Container";
import PageTitle from "../../../components/PageTitle";
import { columns } from "./columns";
import { DataTable } from "./DataTable";

export default function Dashboard() {
  return (
    <Container>
      <PageTitle title="Dashboard" />
      <DataTable columns={columns} />
    </Container>
  );
}
